import React, { useRef }             from 'react';
import { motion }                    from 'framer-motion';
import { Wrapper, WrapperPropsType } from '../wrapper/wrapper.component';
import { useParallax }               from './parallax-image.hook';

type PropsType = {
  src: string;
  height?: number | string;
} & WrapperPropsType;

export const ParallaxImage = (props) => {
    const wrapper = useRef(null);
    const [ parallax ] = useParallax(wrapper);

    return (
        <Wrapper
            ref={ wrapper }
            align="center"
            valign="top"
            margin="xxl"
            overflow="hidden"
            styles={ { maxHeight: props.height } }
            { ...props }
        >
            <motion.img
                className="rte"
                src={ props.src }
                alt=""
                width="100%"
                style={ { transform: `translateY(${ -parallax }px)` } }
            />
        </Wrapper>
    );
};
ParallaxImage.defaultProps = { height: 500 };
